export default __webpack_public_path__ + "static/media/pp-w-9.ca9244d1.svg";